// extracted by mini-css-extract-plugin
export var section = "styles-module--section--6zuZd";
export var container = "styles-module--container--xepbf";
export var logo = "styles-module--logo--RoHhV";
export var content = "styles-module--content--j-Yzv";